import { csrf_headers, getCookie, get_token, get_user_id } from '@/router/index.js';
import { shutdown_push_notifications } from '@/services/push_notification_service';
import { PAGE_LOADER_RESTORED_EVENT } from '@/utils/page_loader';

export const navbar_core_methods = {
  mount_navbar() {
    this.csrfToken = getCookie("csrftoken");
    this.set_internal_suite_flag();
    this.load_navbar_user_context();
    this.get_drive_id();
    this.init_branding();
    this.start_navbar_notifications();
    this.start_platform_access_polling();
    this.register_navbar_events();
  },

  set_internal_suite_flag() {
    const host = (window.location.hostname || "").toLowerCase();
    this.is_internal_suite = host === "1campus.aic-one.com" || host.includes("1campus");
  },

  load_navbar_user_context() {
    this.get_user_details().then(() => this.load_navbar_profile_context());
  },

  load_navbar_profile_context() {
    if (this.user.company_id) {
      this.get_company_profile(this.user.company_id);
      return;
    }
    if (this.user.profile_id) {
      this.get_user_profile(this.user.profile_id);
    }
  },

  start_navbar_notifications() {
    this.fetch_notifications();
    this.fetch_unread_count();
    this.init_chat_socket();
    this.start_notification_polling();
    this.request_notification_permission();
  },

  start_platform_access_polling() {
    this.load_allowed_app_keys();
    this._platform_poll = setInterval(() => {
      this.load_allowed_app_keys();
    }, 15000);
  },

  register_navbar_events() {
    this._drive_mobile_nav_state_handler = event => this.apply_drive_mobile_nav_state(event);
    this._page_loader_restored_handler = () => this.reset_platform_launch_state();
    window.addEventListener('drive-mobile-nav-state', this._drive_mobile_nav_state_handler);
    window.addEventListener(PAGE_LOADER_RESTORED_EVENT, this._page_loader_restored_handler);
    window.addEventListener('refresh-unread-chats', this.fetch_unread_chat_count);
  },

  apply_drive_mobile_nav_state(event) {
    const detail = event?.detail || {};
    this.drive_mobile_nav_mode = detail.mode === 'back' ? 'back' : 'menu';
    this.drive_mobile_nav_title = detail.title || 'My Drive';
  },

  reset_platform_launch_state() {
    this.launching_platform = false;
  },

  unmount_navbar() {
    clearInterval(this.notification_poll_interval);
    this.chat_socket?.disconnect?.();
    clearInterval(this._platform_poll);
    this.unregister_navbar_events();
  },

  unregister_navbar_events() {
    window.removeEventListener('drive-mobile-nav-state', this._drive_mobile_nav_state_handler);
    this._drive_mobile_nav_state_handler = null;
    window.removeEventListener(PAGE_LOADER_RESTORED_EVENT, this._page_loader_restored_handler);
    this._page_loader_restored_handler = null;
    window.removeEventListener('refresh-unread-chats', this.fetch_unread_chat_count);
  },

  emit_drive_mobile_nav() {
    window.dispatchEvent(new CustomEvent('drive-mobile-nav'));
  },

  open_user_modal() {
    this.edit_mode = false;
  },

  async logout() {
    const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/user_logout/`;
    const user_id = get_user_id();
    const token = get_token();
    if (!token) {
      this.$router.push({ name: 'Login' });
      return;
    }

    try {
      await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
          'X-Page-URL': window.location.href,
          ...csrf_headers(this.csrfToken)
        },
        body: JSON.stringify({ user_id })
      });

      shutdown_push_notifications('logout');
      localStorage.clear();
      this.$router.push('/');
    } catch {
      this.$notyf.info('Logout Failed');
    }
  },

  is_admin() {
    const v = localStorage.getItem('is_admin');
    return v === '1' || v === 'true' || v === true || v === 'True';
  },

};
